var topicTags=['办案指引' ,'民事立案','法律法规','刑事会见','调档','案件合作','民事诉讼','刑事辩护','知识产权','刑事自诉','异地代立案', 
'商标','专利','执行', '政策文件', '并购重组','婚姻家事','遗产继承','政策法规','交通事故','工伤','劳动纠纷','诉讼技巧','合同技巧']

// export { topicTags }
module.exports= topicTags;